<script lang="ts" setup>
import { useBasketStore } from '@/store/basket/basket'
import { useCityStore } from '@/store/city/city'
import { useToggleStore } from '@/store/toggle/toggle'

import { wordDeclension } from '@/api/modules/basket/lib'

const basketStore = useBasketStore()
const { basketEnabled } = useToggleStore()
const { currencySymbol } = useCityStore()

const itemsCount = computed(() => {
  return wordDeclension(
    ['товар', 'товара', 'товаров'],
    basketStore.data?.itemsCount,
  )
})

const icon = computed(() => {
  return basketStore.basketIsEmpty && basketStore.isLoaded
    ? 'shopping-card-sad--filled'
    : 'shopping-card-fun--filled'
})

const goToBasket = () => navigateTo('/basket/')

const showEnabledBasket = computed(() => {
  return !basketStore.basketIsDisabled && basketEnabled
})
</script>

<template>
  <div class="header-basket-widget">
    <the-button
      v-if="showEnabledBasket"
      size="sm"
      font="md"
      radius="lg"
      :icon="icon"
      width="140"
      indent-left
      block
      @click="goToBasket"
    >
      <transition name="ui-fade" mode="out-in">
        <span v-if="basketStore.basketIsEmpty">Корзина</span>

        <span v-else class="header-basket-widget__content">
          <span class="header-basket-widget__count">
            {{ itemsCount }}
          </span>

          <span class="header-basket-widget__price">
            {{ basketStore.data.totalPrice }} {{ currencySymbol }}
          </span>
        </span>
      </transition>
    </the-button>

    <the-tooltip v-else position-x="left" position-y="bottom" fixed>
      <template #activator>
        <the-button
          size="sm"
          font="md"
          radius="lg"
          icon="shopping-card-sad--filled"
          width="140"
          block
          disabled
          indent-left
        >
          Корзина
        </the-button>
      </template>
      <span class="header-basket-widget__tooltip">Ресторан не работает</span>
    </the-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.header-basket-widget {
  &__content {
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: left;
  }

  &__count {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }

  &__tooltip {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }
}
</style>
